//
import Model from '@/models/Model'

/**
 * @class
 */
export default class ASentToAuthorized extends Model {

  /**
   * 
   */
  resource() {
    return 'sent_to_authorized'
  }
}
